var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "IFSC", prop: "card_type" } },
        [
          _c("el-input", {
            attrs: {
              placeholder: "请输入 IFSC",
              maxlength: "22",
              clearable: "",
              "show-word-limit": "",
            },
            model: {
              value: _vm.form.card_type,
              callback: function ($$v) {
                _vm.$set(
                  _vm.form,
                  "card_type",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "form.card_type",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "Account Number", prop: "card_no" } },
        [
          _c("el-input", {
            attrs: {
              placeholder: "请输入",
              maxlength: "64",
              clearable: "",
              "show-word-limit": "",
            },
            model: {
              value: _vm.form.card_no,
              callback: function ($$v) {
                _vm.$set(
                  _vm.form,
                  "card_no",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "form.card_no",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "Account Name", prop: "real_name" } },
        [
          _c("el-input", {
            attrs: {
              placeholder: "请输入",
              maxlength: "64",
              clearable: "",
              "show-word-limit": "",
            },
            model: {
              value: _vm.form.real_name,
              callback: function ($$v) {
                _vm.$set(
                  _vm.form,
                  "real_name",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "form.real_name",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }